/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Save_TipInputs */

const en_gc_editor_save_tip = /** @type {(inputs: Gc_Editor_Save_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workbook stays in this browser session. Use File > Save As to download changes before closing.`)
};

const zh_gc_editor_save_tip = /** @type {(inputs: Gc_Editor_Save_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作簿保存在当前浏览器会话中。关闭前请通过“文件 > 另存为”下载修改内容。`)
};

/**
* | output |
* | --- |
* | "Your workbook stays in this browser session. Use File > Save As to download changes before closing." |
*
* @param {Gc_Editor_Save_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_save_tip = /** @type {((inputs?: Gc_Editor_Save_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Save_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_save_tip(inputs)
	return zh_gc_editor_save_tip(inputs)
});
export { gc_editor_save_tip as "gc.editor.save_tip" }